module.exports = __webpack_public_path__ + "static/media/fl.292f803b.png";